/**
 * Retrieves session data from localStorage (set by Firefly SDK on init).
 * @returns {Object} Session data containing sessionHash and sessionHit
 */
export function getSessionData() {
  try {
    const ffsession = localStorage.getItem('ffsession')
    if (ffsession) {
      const sessionData = JSON.parse(ffsession)
      return {
        sessionHash: sessionData.sessionHash,
        sessionHit: sessionData.sessionHit,
      }
    }
  } catch (error) {
    console.error('[Analytics] Failed to parse ffsession:', error)
  }
  return {}
}
